export const delay = (time: number): Promise<void> =>
    new Promise<void>(resolve => setTimeout(resolve, time));

export const brlFormatter = new Intl.NumberFormat('pt-BR', {
    style: 'currency',
    currency: 'BRL',
    minimumFractionDigits: 2
});
export const USDTFormatter = new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: 'USD',
    minimumFractionDigits: 5
});
export const USDTFormatter4digits = new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: 'USD',
    minimumFractionDigits: 4
});
export const USDTFormatter2digits = new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: 'USD',
    minimumFractionDigits: 2
});

export const brlFormatter4Digits = new Intl.NumberFormat('pt-BR', {
    style: 'currency',
    currency: 'BRL',
    minimumFractionDigits: 4
});

export const brlFormatter4DigitsDecimals = new Intl.NumberFormat('en-US', {
    style: 'decimal',
    minimumFractionDigits: 4
});

export const cpfInputFormatter = (cpf: string | null | undefined): string => {
    if (!cpf) return '';

    const slice = (start: number, end: number): string => cpf.slice(start, end);
    const firstBloc = slice(0, 3);
    const secondBloc = slice(3, 6);
    const thirdBloc = slice(6, 9);
    const fourthBloc = slice(9, 11);

    if (!!fourthBloc.length)
        return `${firstBloc}.${secondBloc}.${thirdBloc}-${fourthBloc}`;

    if (!!thirdBloc.length)
        return `${firstBloc}.${secondBloc}.${thirdBloc}`;

    if (!!secondBloc.length)
        return `${firstBloc}.${secondBloc}`;

    return firstBloc;
};

     const cnpjInputFormatter = (cnpj: string | null | undefined): string => {
    if (!cnpj) return '';

    const slice = (start: number, end: number): string => cnpj.slice(start, end);

    const firstBloc = slice(0, 2);
    const secondBloc = slice(2, 5);
    const thirdBloc = slice(5, 8);
    const fourthBloc = slice(8, 12);
    const fifthBloc = slice(12, 14);

    if (!!fifthBloc.length)
        return `${firstBloc}.${secondBloc}.${thirdBloc}/${fourthBloc}-${fifthBloc}`;

    if (!!fourthBloc.length)
        return `${firstBloc}.${secondBloc}.${thirdBloc}/${fourthBloc}`;

    if (!!thirdBloc.length)
        return `${firstBloc}.${secondBloc}.${thirdBloc}`;

    if (!!secondBloc.length)
        return `${firstBloc}.${secondBloc}`;

    return firstBloc;
};

export const documentInputFormatter = (document: string | null | undefined): string => {
    if (!document) return '';
    const handler = document.length > 11 ? cnpjInputFormatter : cpfInputFormatter;
    return handler(document);
};

export const phoneFormatter = (phoneNumber: string): string => {
    const n = phoneNumber;

    const countryCode = `+${n.substring(0, 2)} `;
    const stateCode = `(${n.substring(2, 4)}) `;
    const phone = `${n.substring(4, 5)} ${n.substring(5, 9)}-${n.substring(9,13)}`;

    return countryCode + stateCode + phone;
};

export const isValidDateString = (value: any): boolean =>
    /^(\d{4})-(\d{2})-(\d{2})([T\s](\d{2}):(\d{2}):(\d{2})(\.(\d+)(Z)?)?)?$/.test(value);

export function apiResponseFormatter<T>(obj: T): T {
    if (!obj) return obj;

    if (Array.isArray(obj)) {
        return obj.map(i => apiResponseFormatter(i)) as any;
    }

    if (typeof obj === 'string' && isValidDateString(obj)) {
        return new Date(obj) as any;
    }

    if (typeof obj === 'object' && !(obj instanceof Date)) {
        return Object.keys(obj).reduce((acc, key) => {
            // @ts-ignore
            acc[key] = apiResponseFormatter(obj[key]);
            return acc;
        }, {}) as T;
    }

    return obj;
}

export const getUrlGenerator = (baseUrl: string | undefined) => (...args: (string | number | object)[]) => {

    const params = args
        .map(x => {
            if (typeof x === 'object') {
                const urlParams = new URLSearchParams(x as Record<any, any>);

                const query = Array.from(urlParams.keys())
                    .filter(x => urlParams.get(x) !== 'undefined')
                    .map(x => `${x}=${urlParams.get(x)}`)
                    .join('&');

                return `?${query}`;
            }

            return x;
        })
        .join('/');

    return `${baseUrl}/${params}`;
};